// extracted by mini-css-extract-plugin
export default {"divider":"divider--lSnxU","templatesGrid":"templatesGrid--DzAHR","mobile":"mobile--c_qDD","moreButton":"moreButton--HWvep"};